import { useLocation, Navigate } from 'react-router-dom';

/**
 * Redirects non-trailing-slash routes to trailing-slash versions
 * Except for root "/" which stays as "/"
 */
const TrailingSlashRedirect = () => {
  const location = useLocation();
  const { pathname, search, hash } = location;

  // Don't redirect root
  if (pathname === '/') {
    return null;
  }

  // If pathname doesn't end with "/", redirect to version with trailing slash
  if (!pathname.endsWith('/')) {
    const newPath = `${pathname}/${search}${hash}`;
    return <Navigate to={newPath} replace />;
  }

  return null;
};

export default TrailingSlashRedirect;

